<template>
  <nav class="menu-container">
<h3>深圳出租车</h3>
电召电话 95128<br>
<br>
巡游出租车约车指南<br>
约车指南<br>
巡游出租车有电话和网络两种约车方式，流程如下：<br>

　　一、电话电召流程<br>

　　（一）乘客拨打电召电话95128；<br>

　　（二）座席话务员录入乘客电召信息，系统自动为乘客查找车辆；<br>

　　（三）司机GPS收到电召信息，按确认键进行抢标；<br>

　　（四）中标后司机车载GPS收到乘客详细信息；<br>

　　（五）司机联系乘客，核对信息后乘客上车；<br>

　　（六）乘客上车后，司机按导航前往目的地，并在行程结束后按计价器进行收费。微信支付用户可在微信小程序“出租车助手”中查看乘坐出租车的信息并开具发票。<br>

　　注意事项：如需乘坐无障碍出租车，请拨打电话12385。<br>

　　　二、“深圳出租”网络电召流程<br>

　　（一）在高德地图APP首页选择“打车”，或在微信、支付宝APP选择“高德打车小程序”；<br>

　　（二）确认并输入起点和目的地后，选择“深圳出租”，点击立即叫车，将需求发给附近的司机；<br>

　　（三）司机接到订单后乘客可立即查看车型、车辆颜色、车牌号和驾驶员、车辆信息，以及接驾进度；<br>

　　（四）乘客上车后，司机按导航前往目的地，并在行程结束后按计价器进行收费；<br>

　　（五）乘客完成支付后，本次行程结束。可查询行程，补开发票等。<br>

　　注意事项：司机受理电召任务（电话订单或深圳出租线上订单）后，应在乘客上车后打表，不可在前往途中或到达乘客上车处等待乘客上车期间提前打表。<br>


    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>

</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        // {
          // name: "ershihaoxian",
          // title: "20号线",
          // icon: "chat",
          // exact: true,
        // },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>